import { render, staticRenderFns } from "./DeclarationZoom.vue?vue&type=template&id=890b173a&scoped=true&"
import script from "./DeclarationZoom.vue?vue&type=script&lang=ts&"
export * from "./DeclarationZoom.vue?vue&type=script&lang=ts&"
import style0 from "./DeclarationZoom.vue?vue&type=style&index=0&id=890b173a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890b173a",
  null
  
)

export default component.exports